import { useEffect, useRef } from 'react';
import { useLocation, useSearchParams } from 'react-router';

/** Consume once after both metadata and the filter-period selection settle. */
export default function RequestedAnalysisComparison({ ready, onCompare }: {
  ready: boolean;
  onCompare: (key: string) => void;
}) {
  const [params, setParams] = useSearchParams();
  const location = useLocation();
  const consumed = useRef<string | null>(null);
  const requested = params.get('compare');
  useEffect(() => {
    if (!ready || !requested || consumed.current === location.key) return;
    consumed.current = location.key;
    setParams(previous => {
      const next = new URLSearchParams(previous);
      next.delete('compare');
      return next;
    }, { replace: true });
    onCompare(requested);
  }, [ready, requested, setParams, onCompare, location.key]);
  return null;
}
